import { useCallback, useRef } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import { useIsMemberPortal } from "CrossFeatureComponents/MemberToolbar/stateHooks";
import TwoFA from "Login/TwoFA";
import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";

import FnrLoadingBricks from "UI/FnrLoadingBricks2";

import ActiveContentWrapper from "./ActiveContentWrapper";

const Login = () => {
  const loginWrapperRef = useRef();
  const { setActiveContentKey, setClickAwayDisabled } = useMemberToolbarStore();
  const {
    onAuthChange,
    loginVariant,
    tabID,
    accentColor,
    isDark,
    remoteCancelLoginRef,
  } = useMemberToobarContext();
  const isMemberPortal = useIsMemberPortal();

  const { data, isFetching } = usePostTwoFactorAuth({
    variant: loginVariant,
  });

  const showLoadingSpinner = isFetching && !data;

  const onSuccess = useCallback(
    (payload) => {
      if (onAuthChange) onAuthChange(payload);

      if (isMemberPortal) {
        setActiveContentKey(contentKeys.memberPortalNav);
      } else {
        setActiveContentKey(contentKeys.nothing);
      }

      setClickAwayDisabled(false);
    },
    [onAuthChange, setActiveContentKey, setClickAwayDisabled, isMemberPortal]
  );

  const disabledClickAway = useCallback(() => {
    setClickAwayDisabled(true);
  }, [setClickAwayDisabled]);

  return (
    <ActiveContentWrapper>
      {showLoadingSpinner && (
        <LoadingWrapper>
          <FnrLoadingBricks size={34} loading={true} />
        </LoadingWrapper>
      )}

      <LoginWrapper
        ref={loginWrapperRef}
        data-cy="MemberToolbar_LoginContainer"
      >
        <TwoFA
          showNetwork={false}
          onSuccess={onSuccess}
          noRedirect
          headerText={false}
          variant={loginVariant}
          tabID={tabID}
          accentColor={accentColor}
          isDark={isDark}
          onInputChange={disabledClickAway}
          remoteCancelRef={remoteCancelLoginRef}
          minHeight="180px"
        />
      </LoginWrapper>
    </ActiveContentWrapper>
  );
};

const LoginWrapper = styled.div`
  max-width: 90vw;
  align-items: center;
  display: flex;
`;

const LoadingWrapper = styled.div`
  display: flex;
  padding-top: 20px;
  height: 50px;
  justify-content: center;
  align-items: center;
`;

export default Login;
